import { Header } from '../components/Header'
import { useUsers } from '@hooks/useUsers'
import { Table } from '../components/Table'
import { Spinner } from 'components/loaders'
import { useProjectIntegrations } from '@hooks/useProjectIntegrations'
import { useEmployees } from '@hooks/useEmployee'
import { MenuButton } from 'components/buttons'
import { useTranslation } from 'react-i18next'
import { faPlus } from '@fortawesome/pro-regular-svg-icons'
import { useNewUser } from '../hooks/useNewUser'
import { useMemo } from 'react'

export const UsersAdmin = () => {
  const { t } = useTranslation()
  const { data: users } = useUsers()
  const { data: employees } = useEmployees()
  const { data: projectIntegrations } = useProjectIntegrations()
  const { newUser } = useNewUser()

  // Joined once per fetch rather than on every render: the table keys its row
  // model off this array's identity, so rebuilding it needlessly re-derives
  // every row. The lookup is by id because a linear search per user is
  // quadratic, and both lists run to thousands.
  const usersWithEmployees = useMemo(() => {
    if (!users) return undefined

    const employeesByUserId = new Map(
      employees?.map((employee) => [employee.user.id, employee]),
    )

    return users.map((user) => ({
      ...user,
      employee: employeesByUserId.get(user.id),
    }))
  }, [users, employees])

  return (
    <div className="flex flex-col flex-grow">
      <Header
        actionButton={
          <MenuButton
            className="ml-2"
            title={t('common.action')}
            menuItems={[
              {
                icon: faPlus,
                label: t('features.usersAdmin.addUser'),
                onClick: newUser,
              },
            ]}
          >
            {t('common.action')}
          </MenuButton>
        }
      />
      {usersWithEmployees && users && employees && projectIntegrations ? (
        <Table
          projectIntegrations={projectIntegrations}
          users={usersWithEmployees}
        />
      ) : (
        <Spinner />
      )}
    </div>
  )
}
